export const GW_MESSAGE_CREATE_CONTEXT = "create-context";
export const GW_MESSAGE_ACTIVITY_CREATED = "created";
export const GW_MESSAGE_ACTIVITY_DESTROYED = "destroyed";
export const GW_MESSAGE_CONTEXT_CREATED = "context-created";
export const GW_MESSAGE_CONTEXT_ADDED = "context-added";

export const GW_MESSAGE_SUBSCRIBE_CONTEXT = "subscribe-context";
export const GW_MESSAGE_SUBSCRIBED_CONTEXT = "subscribed-context";
export const GW_MESSAGE_UNSUBSCRIBE_CONTEXT = "unsubscribe-context";

export const GW_MESSAGE_DESTROY_CONTEXT = "destroy-context";
export const GW_MESSAGE_CONTEXT_DESTROYED = "context-destroyed";

export const GW_MESSAGE_UPDATE_CONTEXT = "update-context";
export const GW_MESSAGE_CONTEXT_UPDATED = "context-updated";
export const GW_MESSAGE_JOINED_ACTIVITY = "joined";
